import { jsx as _jsx } from "react/jsx-runtime";
import { ChevronDown, Download } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { memo, useRef, useState } from "react";
import { ASSET_DOWNLOAD_DROPDOWN_MENU_TRIGGER } from "~/constants/testIDs";
export const DownloadButton = /*#__PURE__*/ memo((param)=>{
    let { options } = param;
    const [isOpen, setIsOpen] = useState(false);
    const timeoutRef = useRef();
    if (!options.length) {
        return null;
    }
    const handleMouseEnter = ()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setIsOpen(true);
    };
    const handleMouseLeave = ()=>{
        timeoutRef.current = window.setTimeout(()=>{
            setIsOpen(false);
        }, 100);
    };
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        open: isOpen,
        onOpenChange: setIsOpen,
        align: "end",
        trigger: /*#__PURE__*/ _jsx("div", {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            children: /*#__PURE__*/ _jsx(Button, {
                prefix: /*#__PURE__*/ _jsx(Download, {
                    className: "size-4"
                }),
                suffix: /*#__PURE__*/ _jsx(ChevronDown, {
                    className: "size-4"
                }),
                appearance: "filled",
                color: "grey",
                "data-testid": ASSET_DOWNLOAD_DROPDOWN_MENU_TRIGGER,
                children: "Download"
            })
        }),
        children: /*#__PURE__*/ _jsx("div", {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            children: renderDropdownItems({
                options
            })
        })
    });
});
DownloadButton.displayName = "DownloadButton";
